export const cloudApiConfig = {
  apiRoot() {
    // Use window.location.hostname when FLEX_HOST is enabled
    if (process.env.REACT_APP_FLEX_HOST === 'true') {
      return `${window.location.protocol}//${window.location.hostname}:8080`;
    }

    // Use API_ROOT if provided
    if (process.env.REACT_APP_API_ROOT) {
      return process.env.REACT_APP_API_ROOT;
    }

    // Default to api.ucml.dev
    return 'https://api.ucml.dev';
  },
};

export const stripeApiConfig = (process.env.REACT_APP_ENV || process.env.NODE_ENV) === 'production' ? {
  token: 'pk_live_51IH2WOL6iPPuzcmGCR3iukCyqYnWLolJuaSXyljuuA2j6r8KU7GMzZZ5LJEoL5fZMbI5kULFEttQX0Iqpim06xBW00HDyIOIrH',
  login: '4gwdStecYalC0GQ288',
  redirectURL: 'https://ucml.dev/signup',
} : {
  token: 'pk_test_51RIh2OPskU8SHXP6ueXQboo6waTLZ8xprw1R7PtCZ1OGP0RXSlnff4UtqyJtOko9ULuxqMnkvbAfeqmNOiLTspSs00xnCfzX0h',
  login: 'test_7sIeUW7Kg6KN57q9AB',
  redirectURL: `${window.location.origin}/signup`,
};

export const testMode = process.env.REACT_APP_TEST_MODE === 'true' || process.env.NODE_ENV === 'development';
